<template>
  <div>
    <button-options
      :access="access"
      :hideAdd="true"
      :hideDelete="false"
      :hideDetail="true"
      :hideEdit="false"
      @onDeleteClicked="onDeleteClicked"
      @onEditClicked="onEditClicked"
      @onViewClicked="onViewClicked"/>
  </div>
</template>

<script>
import ButtonOptions from '@/components/directives/button-options';

export default {
  name: 'MasterConfigRpmEdit',
  components: { ButtonOptions },
  props: ['access', 'formData'],
  computed: {
    data() {
      return { ...this.formData };
    },
  },
  methods: {
    onDeleteClicked() {
      this.$emit('onDeleteClicked', this.formData);
    },
    onEditClicked() {
      this.$emit('onEditClicked', this.formData);
    },
    onViewClicked() {
      this.$emit('onViewClicked', this.formData);
    },
  },
};
</script>

<style scoped>

</style>
